<section class="mt-2">
  <i-title [text]="'account.manageParameters' | translate" [buttons]="buttons"></i-title>
  <section class="members mt-3">
    <div class="container">
      <div [formGroup]="form" class="row">
        @if (!hideClassementParams) {
          <div class="members__info col-md-12">
            <span [pTooltip]="'account.allowsShowID' | translate" tooltipPosition="right" class="members__name">
              {{ 'account.showID' | translate }}
            </span>
            <span class="members__state">
              <p-inputSwitch formControlName="ICourrierDisplayClassementId"></p-inputSwitch>
            </span>
          </div>
        }
      </div>
    </div>
  </section>
</section>
